import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"refresh\"><defs><style>#refresh .cls-1{fill:#00c4fb;}</style></defs><path class=\"cls-1\" d=\"M107.74875,20.2125a62.01085,62.01085,0,1,0,16.12,59.2875h-16.12a46.478,46.478,0,1,1-43.7875-62,45.8403,45.8403,0,0,1,32.705,13.795L71.71125,56.25h54.25V2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol